var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bk_toolbar_fixed-top" }, [
    _c(
      "div",
      {
        staticClass: "btn-toolbar",
        attrs: { role: "toolbar", "aria-label": "Toolbar with button groups" }
      },
      [_vm._t("default")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }